/**
 * Site-level constants.
 */
export const INSTAGRAM_URL = 'https://www.instagram.com/revive.worship_?igsh=NjFib3NpY3dsZzY5&utm_source=qr';
export const INSTAGRAM_HANDLE = '@revive.worship_';

/**
 * Live Instagram feed (home page "the journey" grid).
 * Create a free feed at https://behold.so → connect the Revive Instagram
 * account → copy the JSON feed URL → paste it here. Until then the grid
 * shows our own night photos and links to the profile.
 */
export const INSTAGRAM_FEED_URL = '';

export const TIKTOK_URL = 'https://www.tiktok.com/@reviveworship_?_r=1&_t=ZP-95tTGTCMWRb';
export const SUPPORT_EMAIL = 'info@reviveworship.us';
export const BOARD_EMAIL = 'board@reviveworship.us';

export const SITE_NAME = 'Revive Worship';
export const SITE_DOMAIN = 'reviveworship.us';

export const EIN = '42-2367551';

// Single source of truth for the tax-exempt disclosure. Used by the give
// modal, footer, thank-you page, donor portal, and every receipt email/PDF.
export const TAX_DISCLOSURE =
  'Revive Worship is a 501(c)(3) tax-exempt organization. All donations are tax-deductible to the fullest extent permitted by law. EIN 42-2367551.';

// Admin sign-in is restricted to this domain (enforced server-side too).
export const ADMIN_DOMAIN_LABELS = {
  domain: '@reviveworship.us',
  name: 'reviveworship.us',
};
